import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import InputAdornment from "@mui/material/InputAdornment";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import { ApplyCouponModel } from "_models/data/payment/data.applyCoupon.model";
import { ApplyCouponErrorModel } from "_models/errors/payment/error.applyCoupon.model";
import React, { ChangeEvent } from "react";
import InputText from "../forms/inputText";

interface Props {
  couponState: ApplyCouponModel;
  setCouponState: React.Dispatch<React.SetStateAction<ApplyCouponModel>>;
  couponErrors: ApplyCouponErrorModel;
  setCouponErrors: React.Dispatch<React.SetStateAction<ApplyCouponErrorModel>>;
  handleApplyCoupon?: (DATA: ApplyCouponModel) => void;
  handleRemoveCoupon?: () => void;
}
const ApplyCouponForm: React.FC<Props> = ({
  couponState,
  setCouponState,
  couponErrors,
  setCouponErrors,
  handleApplyCoupon,
  handleRemoveCoupon,
}) => {
  const { palette } = useTheme();

  const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    const { name } = e.target;
    setCouponErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleChange = (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.target as HTMLInputElement;
    setCouponState((prev) => ({
      ...prev,
      [name]: value?.toUpperCase(),
      searchResult: null,
    }));
  };

  return (
    <>
      <Box pt={3}>
        <Typography
          sx={{
            fontSize: 12,
            display: "inline-block",
          }}
        >
          {couponState?.isApplicable ? (
            <Box component="span" color={palette.success.main}>
              Coupon successfully applied
            </Box>
          ) : (
            <Box component="span">Have a coupon code?</Box>
          )}
        </Typography>
      </Box>
      <Box>
        <InputText
          variant="outlined"
          color="secondary"
          type="text"
          placeholder="Enter Coupon Code"
          name="coupon"
          value={couponState?.coupon}
          error={!!couponErrors?.coupon}
          errorText={couponErrors?.coupon}
          onChange={handleChange}
          onFocus={handleFocus}
          disabled={couponState?.isApplicable}
          InputProps={{
            endAdornment: couponState?.coupon?.trim() ? (
              <InputAdornment position="end">
                {couponState?.isApplicable ? (
                  <Button
                    onClick={() => handleRemoveCoupon && handleRemoveCoupon()}
                    sx={{
                      py: 0.5,
                      px: 0.5,
                      fontSize: 14,
                    }}
                  >
                    Remove
                  </Button>
                ) : (
                  <Button
                    onClick={() =>
                      handleApplyCoupon && handleApplyCoupon(couponState)
                    }
                    sx={{
                      py: 0.5,
                      px: 0.5,
                      fontSize: 14,
                    }}
                  >
                    Apply
                  </Button>
                )}
              </InputAdornment>
            ) : null,
          }}
        />
      </Box>
    </>
  );
};

export default ApplyCouponForm;
